
(function() {
  var result = { translations: { "es-mx": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "es-mx": "static-7.1189"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1189",
    "ar-eg": "static-7.1189",
    "bg": "static-7.1189",
    "bn": "static-7.1189",
    "ca-es": "static-7.1189",
    "cs": "static-7.1189",
    "da": "static-7.1189",
    "de": "static-7.1189",
    "el": "static-7.1189",
    "en-gb": "static-7.1189",
    "en": "static-7.1189",
    "es-mx": "static-7.1189",
    "es": "static-7.1189",
    "et": "static-7.1189",
    "fi": "static-7.1189",
    "fr-ca": "static-7.1189",
    "fr": "static-7.1189",
    "he-il": "static-7.1189",
    "hi": "static-7.1189",
    "hr": "static-7.1189",
    "hu": "static-7.1189",
    "id": "static-7.1189",
    "it": "static-7.1189",
    "ja": "static-7.1189",
    "ko": "static-7.1189",
    "lt": "static-7.1189",
    "ms": "static-7.1189",
    "nl": "static-7.1189",
    "no": "static-7.1189",
    "pl": "static-7.1189",
    "pt-br": "static-7.1189",
    "pt-pt": "static-7.1189",
    "ro": "static-7.1189",
    "ru": "static-7.1189",
    "sk": "static-7.1189",
    "sl": "static-7.1189",
    "sv": "static-7.1189",
    "th": "static-7.1189",
    "tl": "static-7.1189",
    "tr": "static-7.1189",
    "uk": "static-7.1189",
    "vi": "static-7.1189",
    "x-pseudo": "static-7.1189",
    "zh-cn": "static-7.1189",
    "zh-hk": "static-7.1189",
    "zh-tw": "static-7.1189"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es-mx', {version: 'static-7.1189'}); }
})();


